orders-planner-props
  .left-wrap.order-props
      span.pin-wrap(if="{opts.usePin}" onClick="{togglePin}")
        span.btn.btn-sm.btn-info.icon-btn(if="{opts.pined}")
          i.fas.fa-thumbtack
        span.btn.btn-sm.btn-info.btn-outline-info.icon-btn(if="{!opts.pined}")
          i.fas.fa-thumbtack
      a(href="{opts.show_path}" target="_blank")
        span.job_no.badge.badge-inverse-info
          | { opts.job_no }
      span.under-wrap(onMouseDown="{onMouseDownUnder}")
        span.badge.badge-inverse-success.under(if="{opts.is.under_seller}")
          | { this.locale().under_seller }
          i.feather.icon-chevron-down
        span.badge.badge-inverse-success.under(if="{opts.is.under_operator}")
          | { this.locale().under_operator }
          i.feather.icon-chevron-down
        span.badge.badge-inverse-success.under(if="{opts.is.under_factory}")
          | { this.locale().under_factory }
          i.feather.icon-chevron-down
      span.badge.badge-info.order_type(if="{opts.is.casting_biz}") { this.locale().casting_biz }
      span.badge.badge-info.order_type(if="{opts.is.ct_biz}") { this.locale().ct_biz }
      span.badge.badge-primary.order_type(if="{opts.is.new_order}") { this.locale().new_order }
      span.badge.badge-success.order_type(if="{opts.is.repeater}")   { this.locale().repeater }
      span.badge.badge-warning.order_type(if="{opts.is.changing}")   { this.locale().changing }
      span.status-wrap(onMouseDown="{onMouseDownStatus}")
        span.badge.badge-inverse-default.status(if="{opts.is.information}")
          | { this.locale().information }
          i.feather.icon-chevron-down
        span.badge.badge-default.status(if="{opts.is.unofficial}")
          | { this.locale().unofficial }
          i.feather.icon-chevron-down
        span.badge.badge-warning.status(if="{opts.is.received}")
          | { this.locale().received }
          i.feather.icon-chevron-down
        span.badge.badge-inverse-primary.status(if="{opts.is.pending}")
          | { this.locale().pending }
          i.feather.icon-chevron-down
        span.badge.badge-inverse-danger.secondary.status(if="{opts.is.failed}")
          | { this.locale().failed }
          i.feather.icon-chevron-down
        span.badge.badge-success.status(if="{opts.is.done}")
          | { this.locale().done }
          i.feather.icon-chevron-down
      span.badge.badge-danger.approval(if="{opts.is.not_approved}") { this.locale().not_approved }
      span.client_name { opts.client_name }
      span.client_person_name(if="{opts.client_person_name}")
        i.feather.icon-user.icon-circle
        | { opts.client_person_name }
      span.product
        i.feather.icon-box
        span.product_name { opts.product_name }
        span.product_id { opts.product_product_id }
      span.alerts
        span.no_deadline(if="{!opts.deadline}")
          span.badge.badge-danger
            | { this.locale().no_deadline }
      span.phases
        span.phase.label.label-default(each="{opts.phases}" style="background: { colorcode }" onMouseOver="{onOverOrdersPhase}" onMouseOut="{onOutOrdersPhase}" )
          | { this.phase_name(id) }
  script(type="typescript").
    this.mixin('orders.planner.props')
  style(scoped).
    :scope {
      display: block;
      margin-top: 1rem;
    }
    .left-wrap {
      font-size: 10px;
    }
    .job_no,
    .badge,
    .label.phase {
      margin-right: 1px;
    }
    .badge.status {
      margin-right: .5rem;
    }
    .badge.approval {
      margin-left: -.5rem;
      margin-right: .5rem;
    }
    .client_name,
    .client_person_name,
    .product_name,
    .product_id {
      margin-right: .5rem;
    }
    .phases {
      float: right;
    }
    .phases .label {
      user-select: none;
    }
    .status-wrap,
    .under-wrap {
      display: inline-block;
      cursor: pointer;
    }
    .pin-wrap .btn {
      padding: 1px 12px;
      display: inline-block;
      margin-right: 2px;
    }
